const uploadStatuses = {
  NONE: 0,
  FAILED: 1,
  PENDING: 2,
  UPLOADED: 3,
}

export default uploadStatuses
